// extracted by mini-css-extract-plugin
export default {"login-page":"login-page__3HJZ2","tagline":"tagline__3ysuN"};
    if(module.hot) {
      // 1792145960439
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  